import api from './index';
import { fetchReadableStream } from './fetchReadableStream';

const BASE = '/WFMValue';

export const getWFMValues = async ({
    dateFrom,
    dateTo,
    KPINames,
}: {
    dateFrom: string;
    dateTo: string;
    KPINames: string[];
}) => {
    return api.get(BASE, { params: { dateFrom, dateTo, KPINames } }).then((res) => res.data);
};

export const uploadWFMs = async ({
    data,
    setPercentage,
}: {
    data: any;
    setPercentage?: (percentage: number) => void;
}) => {
    return await fetchReadableStream(`${BASE}`, { data }, setPercentage);
};
